import React, { useState, useEffect, Suspense } from 'react'
import ReactDOM from 'react-dom'
import update from 'immutability-helper'
import moment from 'moment'
import Hints from 'views/pages/UIElements/Hints'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Button, Input, ModalBody, Spinner } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import * as questionBankActions from 'store/QuestionBank/actions'

import {
  faChevronLeft,
  faCog,
  faEdit,
  faList,
  faMinus,
  faPlus,
  faTrash,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CustomModal from './CustomModal'
import Editor from './Editor'
import TextEditor from '../../../TextEditor'
import File from 'views/pages/File'
import Search from 'views/pages/Search'
import { setCount } from 'store/Course/actions'

import './style.css'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import CancelModalButton from 'components/Custom/CancelModalButton'
import Select from 'views/pages/Select'
import Loader from 'views/pages/Loader'

/*eslint-disable*/

const portal = document.createElement('div')
document.body.appendChild(portal)

// Move sortable item
const moveItem = (dragIndex, hoverIndex, props) => {
  const { questions } = props.contentQuiz
  const dragCard = questions[dragIndex]

  const reorderedQuizzes = update(questions, {
    $splice: [
      [dragIndex, 1],
      [hoverIndex, 0, dragCard],
    ],
  })

  props.reorderQuizzess(reorderedQuizzes)
}

const InputRadio = (props) => (
  <div className='custom-control custom-control-info custom-radio mt-3 '>
    <input
      className='custom-control-input '
      type='radio'
      name='option'
      value={props.item.value}
      id={`name-${props.index}`}
      checked={props.question.correct_answer === props.item.id}
      onChange={() => props.onChangeQuestion('correct_answer', props.item.id)}
    />
    <label className='custom-control-label' htmlFor={`name-${props.index}`}>
      {props.label}
    </label>
  </div>
)

const InputCheckbox = (props) => (
  <input
    type='checkbox'
    name='option'
    value={props.item.value}
    id={`name-${props.index}`}
    checked={props.item.correct_answer}
    onChange={() =>
      props.onChangeOption(
        props.index,
        'correct_answer',
        props.item.correct_answer ? null : props.item.id
      )
    }
  />
)

const Question = (props) => {
  const dispatch = useDispatch()

  const onChangeQuestion = (value) => {
    props.onChangeQuestion('name', value)
  }

  const { question } = props

  let language = props.language || {}

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-4'>
          <div className=' d-flex align-items-center'>
            <label className='mb-0 mr-1'>
              {language.courses ? language.courses.points : null}:{' '}
            </label>
            <Input
              style={{ width: '50px' }}
              type='number'
              bsSize='sm'
              min='0'
              value={question.points}
              onChange={(event) =>
                props.onChangeQuestion('points', event.target.value)
              }
              className='mr-1'
            />{' '}
            <div>
              /{' '}
              {props.contentQuiz.questions
                .map((item) => parseInt(item.points))
                .reduce((total, value) => total + value) || 0}
            </div>
          </div>
        </div>
        {/* <div className='col-md-4'>
					<div className='question-buttons-wrapper'>
						{!question.newQuestion ? (
							<button
								className='btn btn-default'
								onClick={props.deleteQuestion.bind(
									null,
									props.quiz.activeIndex
								)}
							>
								{language.general ? language.general.delete : null}
							</button>
						) : null}
						<button className='btn btn-default' onClick={props.undo}>
							{language.general ? language.general.cancel : null}
						</button>
						<button
							className='btn btn-default btn-info'
							onClick={props.saveQuestion}
						>
							{language.general ? language.general.save : null}
						</button>
					</div>
				</div> */}
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='question-title-wrapper mt-2'>
            <TextEditor
              textContent={question.text || question.name}
              onChangeText={onChangeQuestion}
              changeProperty='name'
              placeholder={
                language.courses ? language.courses.question_name : null
              }
              setOptions={{
                buttonList: [
                  ['bold', 'underline', 'italic', 'formatBlock'],
                  ['table', 'image', 'link'],
                ],
              }}
            />
          </div>
        </div>
      </div>
      {question.options.map((item, index) => (
        <div className='row' key={index}>
          <div className='col-12'>
            <div className='question-option-row d-flex'>
              {question.type === 3 ? (
                // <InputCheckbox
                // 	{...props}
                // 	question={question}
                // 	item={item}
                // 	index={index}
                // />
                ''
              ) : question.type === 5 ||
                question.type === 6 ? null : question.type !== 4 &&
                question.type !== 1 &&
                question.type !== 2 ? (
                <InputRadio
                  {...props}
                  question={question}
                  item={item}
                  index={index}
                />
              ) : null}

              {question.type === 1 ? (
                <div className='question-option-wrapper question-type-1-wrapper'>
                  <InputRadio
                    {...props}
                    question={question}
                    item={item}
                    index={index}
                    label={
                      item.value === 1
                        ? language.courses
                          ? language.courses.true
                          : null
                        : language.courses
                        ? language.courses.false
                        : null
                    }
                  />

                  <Button
                    className='btn-icon px-3 py-2 mt-1'
                    color='info'
                    type='button'
                    outline
                    onClick={() =>
                      props.toggleCurrentQuestionDescription(index)
                    }
                  >
                    <span
                      className='btn-inner--icon '
                      style={{ fontSize: '17px' }}
                    >
                      <FontAwesomeIcon
                        icon={item.isDescriptionActive ? faMinus : faPlus}
                      />{' '}
                    </span>
                    <span className='btn-inner--text'>
                      {language.courses
                        ? language.courses.option_feedback
                        : null}
                    </span>
                  </Button>

                  <div
                    className='mt-2'
                    style={{
                      display: item.isDescriptionActive ? '' : 'none',
                    }}
                  >
                    <Editor
                      name='description'
                      onChange={(data) => {
                        props.onChangeOptionDescription(data, index)
                      }}
                      config={{
                        toolbar: ['bold', 'italic', '|', 'link'],
                      }}
                    />
                  </div>
                </div>
              ) : question.type === 5 ||
                question.type === 6 ? null : question.type === 2 ? (
                <div className='question-option-wrapper d-flex my-3 w-100'>
                  <InputRadio
                    {...props}
                    question={question}
                    item={item}
                    index={index}
                  />
                  <div className='col p-0'>
                    <div className='d-flex align-items-center'>
                      <Input
                        className='w-75'
                        type='text'
                        value={item.name}
                        onChange={(e) => {
                          console.log('leart273')
                          props.onChangeOption(index, 'name', e.target.value)
                        }}
                      />
                      {question.options.length > 2 ? (
                        <Button
                          className='ml-2 '
                          size='sm'
                          color='danger'
                          outline
                          onClick={() => props.deleteOption(index)}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                      ) : null}
                    </div>

                    <Button
                      className='btn-icon px-3 py-2 mt-1'
                      color='info'
                      type='button'
                      outline
                      onClick={() =>
                        props.toggleCurrentQuestionDescription(index)
                      }
                    >
                      <span
                        className='btn-inner--icon '
                        style={{ fontSize: '17px' }}
                      >
                        <FontAwesomeIcon
                          icon={item.isDescriptionActive ? faMinus : faPlus}
                        />{' '}
                      </span>
                      <span className='btn-inner--text'>
                        {language.courses
                          ? language.courses.option_feedback
                          : null}
                      </span>
                    </Button>

                    <div
                      className='mt-2'
                      style={{
                        display: item.isDescriptionActive ? '' : 'none',
                      }}
                    >
                      <Editor
                        name='description'
                        onChange={(data) => {
                          props.onChangeOptionDescription(data, index)
                        }}
                        config={{
                          toolbar: ['bold', 'italic', '|', 'link'],
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='mt-3 d-flex align-items-center w-75'>
                  {question.type === 3 && (
                    <input
                      className='mr-1'
                      type='checkbox'
                      name='option'
                      value={item.value}
                      id={`name-${index}`}
                      checked={item.correct_answer}
                      onChange={() =>
                        props.onChangeOption(
                          index,
                          'correct_answer',
                          item.correct_answer ? null : item.id
                        )
                      }
                    />
                  )}

                  <Input
                    type='text'
                    bsSize='sm'
                    value={item.name}
                    onChange={(e) =>
                      props.onChangeOption(index, 'name', e.target.value)
                    }
                  />

                  {question.options.length > 2 ? (
                    <Button
                      className='ml-2'
                      size='sm'
                      color='danger'
                      outline
                      onClick={() => props.deleteOption(index)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      <div className='row'>
        {question.type === 5
          ? question.options.map((item, index) =>
              item.type === 3 ? null : (
                <div key={index} className='col-5 mt-3'>
                  <div className='d-flex align-items-center'>
                    <Input
                      type='text'
                      value={item.name || ''}
                      onChange={(e) =>
                        props.onChangeOption(index, 'name', e.target.value)
                      }
                    />
                    {question.options.length > 2 && item.type === 2 ? (
                      <Button
                        className='ml-2 '
                        size='sm'
                        color='danger'
                        outline
                        onClick={() => props.deleteMatchOption(item.id)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    ) : null}
                  </div>
                </div>
              )
            )
          : null}
      </div>

      <div className='row'>
        {question.type === 6
          ? question.options.map((item, index) => (
              <div key={index} className='col-12'>
                <div className='question-option-row'>
                  <InputRadio
                    {...props}
                    question={question}
                    item={item}
                    index={index}
                  />
                  {item.name ? <span>{item.name}</span> : null}
                  <File
                    onChange={() => props.setOptionImage(index)}
                    placeholder={
                      language.general ? language.general.choose_file : null
                    }
                  />
                  {question.options.length > 2 ? (
                    <button
                      className='btn btn-info'
                      onClick={() => props.deleteMatchOption(item.id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  ) : null}
                </div>
              </div>
            ))
          : null}
      </div>

      <div className='row mt-4'>
        <div className='col-12'>
          <div className='add-option-btn-wrapper'>
            {question.type !== 1 ? (
              <Button outline color='info' onClick={props.addOption}>
                {language.courses ? language.courses.add_response : null}
              </Button>
            ) : null}
          </div>
        </div>
      </div>

      {question.type === 5 ? (
        <h3 className='mt-3'>
          {language.courses ? language.courses.distractions : null}
        </h3>
      ) : null}
      <div className='row mt-2'>
        {question.type === 5
          ? question.options.map((item, index) =>
              item.type === 3 ? (
                <div className='col-5 mt-3' key={index}>
                  <div className='d-flex align-items-center'>
                    <Input
                      type='text'
                      value={item.name || ''}
                      onChange={(e) =>
                        props.onChangeOption(index, 'name', e.target.value)
                      }
                    />
                    {question.options.length > 2 ? (
                      <Button
                        className='ml-2 '
                        size='sm'
                        color='danger'
                        outline
                        onClick={() => props.deleteOption(index)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    ) : null}
                  </div>
                </div>
              ) : null
            )
          : null}
        {question.type === 5 ? (
          <div className='col-12 mt-3'>
            <div className='add-option-btn-wrapper'>
              <Button
                outline
                color='info'
                className='btn'
                onClick={props.addDistraction}
              >
                {language.courses ? language.courses.add_distraction : null}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
      <div className='col-md-4 px-0 my-4  d-inline-block '>
        <div>
          <Button
            className='btn mr-1 px-5 py-2'
            color='info'
            onClick={() => {
              props.saveQuestion()
            }}
          >
            {language.general ? language.general.save : null}
          </Button>
          <Button
            className='btn text-info px-4 py-2'
            color='transparent'
            outline
            onClick={props.undo}
          >
            {language.general ? language.general.cancel : null}
          </Button>
          {/* {!question.newQuestion ? (
						<Button
							className='btn px-4 py-2'
							color='danger'
							outline
							onClick={props.deleteQuestion.bind(
								null,
								props.contentQuiz.activeIndex
							)}
						>
							{language.general ? language.general.delete : null}
						</Button>
					) : null} */}
        </div>
      </div>
    </div>
  )
}

const QuizSettings = (props) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  const quizTimer = useSelector((state) => state.courses.quiz.quizTimer)

  console.log('542 leon', props.contentQuiz)

  const today = moment().format('YYYY-MM-DD')

  // let date = props.quiz.quizStartDate && new Date(props.quiz.quizStartDate)
  // const stringDate = date && date.toLocaleDateString()
  // const replacedDate = stringDate && stringDate.replaceAll('/', '-')
  // const quizStartDate =
  // 	replacedDate && moment(replacedDate).format('YYYY-MM-DD')

  return (
    <div className=''>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>
            {language.courses ? language.courses.quiz_pass_percentage : null}
          </span>
          <Hints
            message={'Allows managers to set quiz pass percentage value'}
          />
        </div>
        <div className='question-toggle-container gap06'>
          {props.contentQuiz.isPassPercentageActive ? (
            <div className='d-flex align-items-center justify-content-start gap06'>
              <Input
                style={{ width: '100%' }}
                bsSize='sm'
                min={0}
                max={100}
                type='number'
                name='group_length'
                onChange={(event) =>
                  props.setPassPercentage(event.target.value)
                }
                value={props.contentQuiz.quizPassPercentage || ''}
              />
              <label className='ml-1 '>%</label>
            </div>
          ) : null}
          <div className='mr-3'>
            <label className='custom-toggle'>
              <input
                type='checkbox'
                checked={props.contentQuiz.isPassPercentageActive || false}
                onChange={props.togglePassPercentage}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>Set quiz timer</span>
          <Hints message={'Allows managers to set quiz timer'} />
        </div>
        <div className='question-toggle-container gap06'>
          {props.contentQuiz.isQuizTimerActive ? (
            <div className='d-flex align-items-center justify-content-start gap06'>
              <Input
                style={{ width: '100%' }}
                bsSize='sm'
                type='number'
                name='group_length'
                min={0}
                max={3}
                onChange={(event) => dispatch(setCount(event.target.value))}
                value={quizTimer ?? ''}
              />
              <label className='ml-1'>minutes</label>
            </div>
          ) : null}
          <div className='mr-3'>
            <label className='custom-toggle '>
              <input
                type='checkbox'
                checked={props.contentQuiz.isQuizTimerActive || false}
                onChange={props.toggleQuizTimer}
              />
              <span className='custom-toggle-slider rounded-circle' />
            </label>
          </div>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>
            {language.courses ? language.courses.randomize_options_order : null}
          </span>
          <Hints
            message={'Allows managers to set randomize order of the questions'}
          />
        </div>
        <div className='mr-3'>
          <label className='custom-toggle'>
            <input
              type='checkbox'
              checked={props.contentQuiz.randomizeOrder}
              onChange={props.toggleRandomizeOrder}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
      <div className='config-row'>
        <div className='with-hint item'>
          <span>Content quiz passable</span>
          <Hints
            message={
              'Permit to pass content without finishing the content quiz'
            }
          />
        </div>
        <div className='mr-3'>
          <label className='custom-toggle'>
            <input
              type='checkbox'
              checked={props.contentQuiz.passable}
              onChange={props.toggleContentQuizPassable}
            />
            <span className='custom-toggle-slider rounded-circle' />
          </label>
        </div>
      </div>
    </div>
  )
}

const QuizOverlayHeader = (props) => {
  const coursesOverviewState = useSelector(
    (store) => store.dashboard.coursesOverviewState
  )
  const dispatch = useDispatch()
  let language = props.language || {}

  const questionOptions = [
    {
      name: language.courses ? language.courses.add_new_question : null,
      value: '0',
    },
    { name: language.courses ? language.courses.true_false : null, value: '1' },
    {
      name: language.courses ? language.courses.multiple_choice : null,
      value: '2',
    },
    { name: language.courses ? language.courses.checkbox : null, value: '3' },
    {
      name: language.courses ? language.courses.correct_order : null,
      value: '4',
    },
    { name: language.courses ? language.courses.matching : null, value: '5' },
    { name: language.courses ? language.courses.image : null, value: '5' },
  ]

  return (
    <div
    // style={{
    //   display: 'flex',
    //   flexDirection: 'column',
    //   flexGrow: 1,
    //   height: '100%', // Set height to 100%
    // }}
    >
      <div>
        <input
          name='title'
          placeholder='Quiz Title'
          required=''
          type='text'
          class='form-control'
          autoFocus
          value={props.contentQuiz ? props.contentQuiz.title : ''}
          onChange={(event) =>
            props.onChangeContentQuizName(event.target.value)
          }
        />
      </div>
      <div className='d-flex justify-content-between mt-2 '>
        <div className='d-flex gap06'>
          {/* <Input
            className='add-question  border-info btn-outline-info text-info font-weight-bolder h-100'
            style={{ width: 'unset' }}
            name='language'
            type='select'
            onChange={props.selectQuestion}
            onClick={() => props.handleAddNewQuestion()}
          >
            {questionOptions.map((item, index) => (
              <option
                key={index}
                value={item.value}
                className='text-dark bg-white'
              >
                {item.name}
              </option>
            ))}
          </Input> */}
          <div onClick={() => props.handleAddNewQuestion()}>
            <Select
              options={questionOptions.slice(1, questionOptions.length)}
              onChange={(e) => props.selectQuestion(e)}
              language={language}
              placeholder='Add new question'
              multi={false}
              customStyle={true}
            />
          </div>
          <button
            onClick={() =>
              props.handleClickQuizSettings(!props.isQuizSettingsOpened)
            }
            className='btn btn-outline-info'
          >
            <FontAwesomeIcon
              icon={props.isQuizSettingsOpened ? faChevronLeft : faCog}
              className='mr-2'
            />
            {props.isQuizSettingsOpened
              ? 'Back to questions list'
              : 'Quiz settings'}
          </button>
          <button
            onClick={() => props.handleClickQuestionBank()}
            className='btn btn-outline-info ml-0'
          >
            <FontAwesomeIcon icon={faList} className='mr-2' />

            {props.isQuestionBankOpened
              ? 'Back to questions list'
              : 'Select from question bank'}
          </button>
        </div>
        <span className='align-self-end h4'>
          {props.contentQuiz.questions.length}{' '}
          {language.courses ? language.courses.questions : null}{' '}
        </span>
      </div>
    </div>
  )
}

function QuizOverlay(props) {
  const [isQuizSettingsOpened, setIsQuizSettingsOpened] = useState(false)
  const [isQuestionBankOpened, setIsQuestionBankOpened] = useState(false)
  const dispatch = useDispatch()

  const handleClickQuizSettings = () => {
    setIsQuizSettingsOpened(!isQuizSettingsOpened)
    setIsQuestionBankOpened(false)
  }

  const handleClickQuestionBank = () => {
    setIsQuestionBankOpened(!isQuestionBankOpened)
    setIsQuizSettingsOpened(false)
  }

  const handleAddNewQuestion = () => {
    setIsQuizSettingsOpened(false)
    setIsQuestionBankOpened(false)
  }

  const handleSaveQuiz = () => {
    if (props.contentQuiz && props.contentQuiz.title.trim().length == 0) {
      confirm('Plase give a title for the quiz')
      return
    } else if (
      props.contentQuiz &&
      props.contentQuiz.questions &&
      props.contentQuiz.questions.length == 0
    ) {
      {
        confirm('Plase add questions to the quiz')

        return
      }
    }

    props.saveContentQuiz()
    props.history.goBack()
  }

  return (
    <>
      <div className='row justify-content-between question-items-header'>
        <div className='col-md-12'>
          <QuizOverlayHeader
            isQuizSettingsOpened={isQuizSettingsOpened}
            isQuestionBankOpened={isQuestionBankOpened}
            handleClickQuizSettings={handleClickQuizSettings}
            handleClickQuestionBank={handleClickQuestionBank}
            handleAddNewQuestion={handleAddNewQuestion}
            {...props}
          />
        </div>
        <div className='col-md-12  mt-3'>
          {isQuizSettingsOpened ? (
            <QuizSettings
              handleClickQuizSettings={handleClickQuizSettings}
              {...props}
            />
          ) : isQuestionBankOpened ? (
            <QuestionBankList
              {...props}
              handleClickQuestionBank={handleClickQuestionBank}
            />
          ) : (
            <List {...props} />
          )}
        </div>
      </div>
      <div className='d-flex '>
        <button
          onClick={() => {
            dispatch(invalidateCoursesOverview())
            handleSaveQuiz()
          }}
          className='btn btn-info'
        >
          Save Content Quiz
        </button>

        <CancelModalButton
          customFn={() => {
            // eslint-disable-next-line
            if (
              !confirm(
                'Are you sure you want to cancel? Changes will not be saved.'
              )
            ) {
              return
            }
            props.history.goBack()
          }}
        />
      </div>
    </>
  )
}
const FolderItem = (props) => {
  return (
    <div
      onClick={() => props.setOpenedFolder(props.folder)}
      key={props.folder.id}
      className='all-folder-containers'
    >
      <div className='book-item-question-bank rounded'>
        <a
          href={props.folder.path}
          target='_blank'
          className='folder-item-container'
        >
          {/* <FontAwesomeIcon
						style={{ color: '#c9c9c9', fontSize: '30px', marginRight: '5px' }}
						icon='folder'
						className='icon fas'
					/> */}
          <h5 title={props.folder.name}>{props.folder.name}</h5>
        </a>
      </div>
    </div>
  )
}

const QuestionBankList = (props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(questionBankActions.fetchAllFoldersFromQuestionBank())
  }, [])
  const language = props.language || {}
  const questionBank = useSelector((state) => state.questionBank)
  const { questions: quizQuestions = [] } = props.contentQuiz
  const [questionData, setQuestionData] = useState(null)
  const [type, setType] = useState('')

  const [questionArray, setQuestionArray] = useState([])
  const [searchQuestion, setSearchQuestion] = useState('')
  // const questionBank = useSelector((state) => state.questionBank)

  const handleAddQuestion = (question) => {
    if (!questionArray.includes(question)) {
      setQuestionArray([...questionArray, question])
    } else {
      setQuestionArray(questionArray.filter((ques) => ques.id !== question.id))
    }
  }

  const filteredQuestions = questionBank.questions.filter((item) =>
    item.name.includes(searchQuestion.toLowerCase())
  )

  const isQuizQuestionsIncluded =
    questionBank.questions.length > 0 && quizQuestions.length > 0
      ? questionBank.questions.every((question) =>
          quizQuestions.some((quest) => quest.id === question.id)
        )
      : false

  const handleSaveQuestions = () => {
    props.saveQuestionFromBank(questionArray)
    setQuestionArray([])
  }

  const handleCancel = () => {
    props.handleClickQuestionBank()
  }

  return (
    <div className='questions-container '>
      <div className='my-3'>
        {!isQuizQuestionsIncluded && questionBank.questions.length > 0 && (
          <div className='d-flex justify-content-between'>
            <div>
              <button
                className='btn btn-sm bg-transparent mr-1'
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className='btn  btn-info py-1 px-3'
                onClick={handleSaveQuestions}
              >
                Add questions
              </button>
            </div>
            <Search
              placeholder='Search Question'
              value={searchQuestion}
              onChange={(event) => setSearchQuestion(event.target.value)}
            />
          </div>
        )}
      </div>

      {questionBank.openedFolder ? (
        <div
          style={{
            display: 'flex',
            position: 'relative',
            marginBottom: '20px',
          }}
        >
          <span
            onClick={() => dispatch(questionBankActions.setCloseFolder())}
            className='back-to-question-bank'
          >
            Question Bank{' '}
          </span>{' '}
          {` > `}
          <span className='selected-folder'>
            {questionBank.openedFolder.name}
          </span>
        </div>
      ) : (
        <div style={{ marginBottom: '40px' }}>
          <div className='folders-count'>{`Folders (${
            questionBank &&
            questionBank.allFolders &&
            questionBank.allFolders.length
          })`}</div>
          <div className='question-bank-folder-container'>
            {questionBank &&
            questionBank.allFolders &&
            questionBank.allFolders.length
              ? questionBank.allFolders.map((folder) => {
                  return (
                    <FolderItem
                      {...props}
                      folder={folder}
                      setOpenedFolder={(folder) =>
                        dispatch(questionBankActions.setOpenedFolder(folder))
                      }
                    />
                  )
                })
              : ''}
          </div>
        </div>
      )}
      <Suspense
        fallback={
          <div className='text-center'>
            {/* <Spinner /> */}
            <Loader />
          </div>
        }
      >
        {/* <div className='col-12'>
					<QuestionList
						setQuestionData={setQuestionData}
						searchQuestion={searchQuestion}
						setType={setType}
						setOpenMoveQuestion={(id) =>
							dispatch(questionBankActions.setOpenMoveQuestion(id))
						}
						moveQuestionOnChange={(event) =>
							dispatch(questionBankActions.moveQuestionOnChange(event))
						}
						language={language}
						{...questionBank}
					/>
				</div> */}
      </Suspense>
      {filteredQuestions.map((item, index) =>
        quizQuestions.some((question) => question.id === item.id) ? null : (
          <QuestionContainer
            manageAddingQuestion={handleAddQuestion}
            item={item}
            index={index}
            key={index}
          />
        )
      )}
      {isQuizQuestionsIncluded
        ? 'You have selected all questions from Question Bank'
        : questionBank.questions.length === 0 &&
          'There are no questions available in question bank'}
    </div>
  )
}

const QuestionContainer = ({ item, index, manageAddingQuestion }) => {
  const [active, setActive] = useState(false)

  const handleClick = () => {
    setActive(!active)
    manageAddingQuestion(item)
  }

  const shortenText = () => {
    let text = item.name
    if (
      typeof text === 'string' &&
      text.includes('src=') &&
      text.includes('<p>')
    ) {
      text = text.split('</p>')[0].slice(0, 100) + '</p>'
    } else if (text.includes('se-image-container')) {
      text =
        text.split('se-image-container')[0] +
        'image-size' +
        text.split('se-image-container')[1]
    } else {
      text = text.split('</p>')[0].slice(0, 100) + '</p>' || item.text
    }
    return text
  }

  return (
    <div
      className={`question-container border rounded mb-2 p-3 ${
        active ? 'active' : ''
      }`}
      onClick={handleClick}
    >
      <div className='question-number'>{index + 1}</div>
      <div
        dangerouslySetInnerHTML={{ __html: shortenText() }}
        className='col-11  dangerous-html'
      />
    </div>
  )
}

function PortalAwareItem({ provided, snapshot, item, index, props }) {
  const usePortal = snapshot.isDragging

  const child = (
    <div
      className={`col-12 mb-2 p-2 border rounded draggable-item  draggable-bg   ${
        snapshot.isDragging ? 'active' : ''
      }`}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
    >
      <strong>{index + 1}</strong>
      <div
        key={index}
        dangerouslySetInnerHTML={{
          __html: (typeof item.name === 'string' && item.name) || item.text,
        }}
        className='col-11 question-item-title-select  text-darker dangerous-html py-1'
      />
      <div className='col-auto d-flex'>
        <Button
          className='bg-transparent btn-sm shadow-none border-none'
          onClick={props.editQuestion.bind(null, index)}
        >
          <FontAwesomeIcon icon={faEdit} />
        </Button>
        <Button
          className='bg-transparent btn-sm shadow-none border-none ml-0'
          onClick={props.deleteQuestion.bind(null, index)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </div>
    </div>
  )

  if (!usePortal) {
    return child
  }

  // if dragging - put the item in a portal
  return ReactDOM.createPortal(child, portal)
}

const List = (props) => {
  const handleOnDragEnd = (result) => {
    if (!result.destination) return
    moveItem(result.source.index, result.destination.index, props)
  }
  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable key='questions' droppableId='questions'>
        {(droppableProvided) => (
          <div
            {...droppableProvided.droppableProps}
            ref={droppableProvided.innerRef}
          >
            {props.contentQuiz.questions.map((item, index) => {
              return (
                <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={index}
                >
                  {(draggableProvided, draggableSnapshot) => (
                    <PortalAwareItem
                      item={item}
                      provided={draggableProvided}
                      snapshot={draggableSnapshot}
                      index={index}
                      props={props}
                    />
                  )}
                </Draggable>
              )
            })}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

const ContentQuiz = (props) => {
  let language = props.language || {}

  useEffect(() => {}, [props.contentQuiz])
  return (
    <CustomModal
      courseId={props.course_id}
      title={'Add Content Quiz'}
      size='xl'
      className='question-modal'
      customFn={() => {
        // eslint-disable-next-line
        if (
          !confirm(
            'Are you sure you want to cancel? Changes will not be saved.'
          )
        ) {
          return false
        } else return true
      }}
    >
      <ModalBody
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {(() => {
          switch (props.contentQuiz.activeIndex) {
            case -1:
              return <QuizOverlay {...props} />
            default:
              return (
                <Question
                  {...props}
                  question={
                    props.contentQuiz.questions[props.contentQuiz.activeIndex]
                  }
                />
              )
          }
        })()}
      </ModalBody>
    </CustomModal>
  )
}

export default ContentQuiz
